import React, { useState } from 'react'

const Comment = () => {
    const [ActiveTab, setActiveTab] = useState('Accesories');

    const handleTabchange = (tab) => {
        setActiveTab(tab);
    }
    return (
        <>
            <section id="product-dtl-comment" className="product-dtl-comment-main-block">
                <div className="container">
                    <div className="product-dtl-comment-block">
                        <div className="row">
                            <div className="col-lg-12">
                                <ul
                                    className="product-dtl-comment-nav nav nav-pills"
                                    id="pills-tab"
                                    role="tablist"
                                >
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${ActiveTab === "Accesories" ? "active" : ""}`}
                                            onClick={() => handleTabchange("Accesories")}
                                            id="pills-accesories-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-accesories"
                                            type="button"
                                            role="tab"
                                            aria-controls="pills-accesories"
                                            aria-selected="true"
                                        >
                                            Accesories
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${ActiveTab === "  Description" ? "active" : ""}`}
                                            onClick={() => handleTabchange("Description")}
                                            id="pills-description-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-description"
                                            type="button"
                                            role="tab"
                                            aria-controls="pills-description"
                                            aria-selected="false"
                                        >
                                            Description
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${ActiveTab === "Specificaton" ? "active" : ""}`}
                                            onClick={() => handleTabchange("Specificaton")}
                                            id="pills-specificaton-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-specificaton"
                                            type="button"
                                            role="tab"
                                            aria-controls="pills-specificaton"
                                            aria-selected="false"
                                        >
                                            Specificaton
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${ActiveTab === "Reviews" ? "active" : ""}`}
                                            onClick={() => handleTabchange("Reviews")}
                                            id="pills-reviews-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-reviews"
                                            type="button"
                                            role="tab"
                                            aria-controls="pills-reviews"
                                            aria-selected="false"
                                        >
                                            Reviews
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="tab-content" id="pills-tabContent">
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Accesories' ? 'show active' : ''}`}
                                    id="pills-accesories"
                                    role="tabpanel"
                                    aria-labelledby="pills-accesories-tab"
                                >
                                    <div className="accesories-block">
                                        <ul>
                                            <li>Power Adapter</li>
                                            <li>USB Cable</li>
                                            <li>SIM Tray Ejector</li>
                                            <li>Quick Start Guide</li>
                                            <li>Warranty Card</li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Description' ? 'show active' : ''}`}
                                    id="pills-description"
                                    role="tabpanel"
                                    aria-labelledby="pills-description-tab"
                                    
                                >
                                    <div className="description-block">
                                        <p>
                                            Lorem Ipsum is simply dummy text of the printing and typesetting
                                            industry. Lorem Ipsum has been the industry's standard dummy
                                            text ever since the 1500s, when an unknown printer took a galley
                                            of type and scrambled it to make a type specimen book. It has
                                            survived not only five centuries, but also the leap into
                                            electronic typesetting, remaining essentially unchanged. It was
                                            popularised in the 1960s with the release of Letraset sheets
                                            containing Lorem Ipsum passages, and more recently with desktop
                                            publishing software like Aldus PageMaker including versions of
                                            Lorem Ipsum.
                                        </p>
                                        <p>
                                            It is a long established fact that a reader will be distracted
                                            by the readable content of a page when looking at its layout.
                                            The point of using Lorem Ipsum is that it has a more-or-less
                                            normal distribution of letters, as opposed to using 'Content
                                            here, content here', making it look like readable English. Many
                                            desktop publishing packages and web page editors now use Lorem
                                            Ipsum as their default model text, and a search for 'lorem
                                            ipsum' will uncover many web sites still in their infancy.{" "}
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Specificaton' ? 'show active' : ''}`}
                                    id="pills-specificaton"
                                    role="tabpanel"
                                    aria-labelledby="pills-specificaton-tab"
                                    
                                >
                                    <div className="specification-block">
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">General</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Brand</th>
                                                        <td>XYZ</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Model Name/Number</th>
                                                        <td>ABC2D23EFGH</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Display</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Screen Size</th>
                                                        <td>6.67 inches</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Display Type</th>
                                                        <td>Amoled</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Resolution</th>
                                                        <td>1080x2400 pixels</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Refresh Rate</th>
                                                        <td>120Hz</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Processor</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Chipset</th>
                                                        <td>Snapdragon</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">CPU</th>
                                                        <td>Octa-core</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">GPU</th>
                                                        <td>Graphics Processing Unit</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Operating System</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">OS Version</th>
                                                        <td>Android 12</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Memory &amp; Storage</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">RAM</th>
                                                        <td>6GB</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Internal Storage</th>
                                                        <td>128GB</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Expandable Storage</th>
                                                        <td>MicroSD card support and up to how much</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Camera</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Number of lenses</th>
                                                        <td>Triple camera</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Resolution</th>
                                                        <td>48MP + 8MP + 2MP</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Features</th>
                                                        <td>Night Mode, HDR, Optical Zoom, etc.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Battery</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Battery Capacity</th>
                                                        <td>5000mAh</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Charging Speed</th>
                                                        <td>30W fast charging</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Battery Type</th>
                                                        <td>Lithium-ion, Lithium-polymer</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Connectivity</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Network Support</th>
                                                        <td>5G, 4G LTE, etc</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">SIM Type</th>
                                                        <td>Dual SIM, eSIM</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Wi-Fi</th>
                                                        <td>Wi-Fi standards supported</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Bluetooth Version</th>
                                                        <td>Bluetooth 5.1</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">NFC</th>
                                                        <td>Yes/No</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">USB Type</th>
                                                        <td>USB Type-C</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Sensors</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Fingerprint Sensor</th>
                                                        <td>In-display, side-mounted, rear-mounted</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Face Unlock</th>
                                                        <td>Yes/No</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Audio</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Speaker Type</th>
                                                        <td>Mono</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Headphone Jack</th>
                                                        <td>Yes/No</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="table-responsive">
                                            <h3 className="based-comment-title">Build &amp; Design</h3>
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Weight </th>
                                                        <td>200g</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Dimensions</th>
                                                        <td>165 x 76 x 8 mm</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Material</th>
                                                        <td>Glass, Plastic, Metal</td>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Water/Dust Resistance</th>
                                                        <td>IP68</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`tab-pane fade ${ActiveTab === 'Reviews' ? 'show active' : ''}`}
                                    id="pills-reviews"
                                    role="tabpanel"
                                    aria-labelledby="pills-reviews-tab"
                                    
                                >
                                    <div className="based-comment-block">
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <h3 className="based-comment-title">Besed In 2 Comment</h3>
                                                <div className="based-total-rating">
                                                    <ul className="d-flex product-star-rating">
                                                        <li>
                                                            <span>4.5</span>
                                                        </li>
                                                        <li className="icons">
                                                            <i className="flaticon-star star-yellow" />
                                                        </li>
                                                        <li className="icons">
                                                            <i className="flaticon-star star-yellow" />
                                                        </li>
                                                        <li className="icons">
                                                            <i className="flaticon-star star-yellow" />
                                                        </li>
                                                        <li className="icons">
                                                            <i className="flaticon-star star-yellow" />
                                                        </li>
                                                        <li className="icons">
                                                            <i className="flaticon-star star-grey" />
                                                        </li>
                                                    </ul>
                                                </div>
                                                <ul className="based-comment-list">
                                                    <li>
                                                        <ul className="d-flex product-star-rating">
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <div className="progress-block">
                                                            <progress
                                                                className="progress-bar"
                                                                value={20}
                                                                max={100}
                                                            />
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span>01</span>
                                                    </li>
                                                </ul>
                                                <ul className="based-comment-list">
                                                    <li>
                                                        <ul className="d-flex product-star-rating">
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <div className="progress-block">
                                                            <progress
                                                                className="progress-bar"
                                                                value={20}
                                                                max={100}
                                                            />
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span>01</span>
                                                    </li>
                                                </ul>
                                                <ul className="based-comment-list">
                                                    <li>
                                                        <ul className="d-flex product-star-rating">
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <div className="progress-block">
                                                            <progress
                                                                className="progress-bar"
                                                                value={0}
                                                                max={100}
                                                            />
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span>01</span>
                                                    </li>
                                                </ul>
                                                <ul className="based-comment-list">
                                                    <li>
                                                        <ul className="d-flex product-star-rating">
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <div className="progress-block">
                                                            <progress
                                                                className="progress-bar"
                                                                value={0}
                                                                max={100}
                                                            />
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span>01</span>
                                                    </li>
                                                </ul>
                                                <ul className="based-comment-list">
                                                    <li>
                                                        <ul className="d-flex product-star-rating">
                                                            <li className="icons">
                                                                <i className="flaticon-star star-yellow" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                            <li className="icons">
                                                                <i className="flaticon-star star-grey" />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <div className="progress-block">
                                                            <progress
                                                                className="progress-bar"
                                                                value={0}
                                                                max={100}
                                                            />
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span>01</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-4 mt-4 mt-lg-0">
                                                <h3 className="based-comment-title">Add Your Comment</h3>
                                                <ul className="add-comment-block">
                                                    <li>
                                                        <div className="row">
                                                            <div className="col-lg-3">
                                                                <label className="form-label mt-0">Rating</label>
                                                            </div>
                                                            <div className="col-lg-9">
                                                                <i className="flaticon-star star-yellow" />
                                                                <i className="flaticon-star star-yellow" />
                                                                <i className="flaticon-star star-yellow" />
                                                                <i className="flaticon-star star-yellow" />
                                                                <i className="flaticon-star star-grey" />
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <form>
                                                            <div className="row">
                                                                <div className="col-lg-3">
                                                                    <label
                                                                        htmlFor="floatingName"
                                                                        className="form-label"
                                                                    >
                                                                        Name
                                                                    </label>
                                                                </div>
                                                                <div className="col-lg-9">
                                                                    <div className="form-floating">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="floatingName"
                                                                            placeholder="Your Name"
                                                                        />
                                                                        <label htmlFor="floatingName">Your Name</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </li>
                                                    <li>
                                                        <form>
                                                            <div className="row">
                                                                <div className="col-lg-3">
                                                                    <label
                                                                        htmlFor="floatingAddress"
                                                                        className="form-label"
                                                                    >
                                                                        Address
                                                                    </label>
                                                                </div>
                                                                <div className="col-lg-9">
                                                                    <div className="form-floating">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="floatingAddress"
                                                                            placeholder="Your Address"
                                                                        />
                                                                        <label htmlFor="floatingAddress">
                                                                            Your Address
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </li>
                                                    <li>
                                                        <form>
                                                            <div className="row">
                                                                <div className="col-lg-3">
                                                                    <label
                                                                        htmlFor="floatingMessage"
                                                                        className="form-label"
                                                                    >
                                                                        Review
                                                                    </label>
                                                                </div>
                                                                <div className="col-lg-9">
                                                                    <div className="form-floating">
                                                                        <textarea
                                                                            className="form-control"
                                                                            placeholder="Leave a comment here"
                                                                            id="floatingMessage"
                                                                            rows={2}
                                                                            defaultValue={""}
                                                                        />
                                                                        <label htmlFor="floatingMessage">Message</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </li>
                                                    <li className="add-comment-button">
                                                        <button type="button" className="btn btn-primary">
                                                            Add Review
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="customers-review-block">
                                        <ul className="d-flex product-star-rating">
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                        </ul>
                                        <p>
                                            Ecommerce is the buying and selling of goods and services over
                                            the internet. It revolutionizes the way businesses operate,
                                            providing convenience and access to a global market. Ecommerce
                                            platforms enable online stores to showcase products, process
                                            payments, and deliver purchases to customers' doorsteps
                                            Ecommerce is the buying and selling of goods and services
                                        </p>
                                        <h4 className="customer-name">
                                            Salim Mana <span className="date">25June 2025</span>
                                        </h4>
                                    </div>
                                    <div className="customers-review-block">
                                        <ul className="d-flex product-star-rating">
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                            <li className="icons">
                                                <i className="flaticon-star star-yellow" />
                                            </li>
                                        </ul>
                                        <p>
                                            Ecommerce is the buying and selling of goods and services over
                                            the internet. It revolutionizes the way businesses operate,
                                            providing convenience and access to a global market. Ecommerce
                                            platforms enable online stores to showcase products, process
                                            payments, and deliver purchases to customers' doorsteps
                                            Ecommerce is the buying and selling of goods and services
                                        </p>
                                        <h4 className="customer-name">
                                            Nazim On <span className="date">25June 2025</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Comment
